var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"file_input",attrs:{"accept":_vm.acceptedFormats,"type":"file"},domProps:{"value":_vm.files},on:{"change":_vm.onFileChange}})}
var staticRenderFns = []

export { render, staticRenderFns }